module.exports = __webpack_public_path__ + "static/media/iconActivewallet.94166eb2.svg";